import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import OrderBySelect from '../components/OrderBySelect'
import { colors, fontFamilies } from '../../search-common/settings'
import { media } from '../../search-common/helpers'
import PropTypes from 'prop-types'
import { translate, translateN } from '../../modules/helper-functions'

const Container = styled.div`
  width: 100%;
  background-color: ${colors.grayTone1};
`

const Wrapper = styled.div`
  position: relative;
  margin: 0 auto;
  max-width: 1440px;
  width: 100%;
  padding: 0 24px;
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
  ${media.tablet`
    grid-gap: 20px;
    grid-template-columns: 1fr 1fr;
    justify-content: space-between;
  `}
`

const Item = styled.div`
  ${media.tablet`
    &:first-child {
      justify-self: start;
    }
    &:last-child {
      justify-self: end;
    }
  `}
`

const ResultCount = styled.p`
  font-family: ${fontFamilies.aeonik};
  font-size: 14px;
  color: ${colors.gray};
  margin: 0;
  font-weight: bold;
`

/**
 * VisibilityFilters container.
 */
const VisibilityFilters = ({ resultsAmount, translations }) => (
  <Container>
    <Wrapper>
      <Item>
        <ResultCount>{resultsAmount > 0 ? translateN( translations, '%d result found', resultsAmount ) : translate( translations, 'No results found.' )}</ResultCount>
      </Item>
      <Item>
        <OrderBySelect />
      </Item>
    </Wrapper>
  </Container>
)

/**
 * Map the redux state to component props.
 *
 * @param {object} state
 * @return {object}
 */
const mapStateToProps = ( state ) => ({
  translations: state.translations
})

VisibilityFilters.propTypes = {
  resultsAmount: PropTypes.number,
  translations: PropTypes.object.isRequired
}

export default connect( mapStateToProps )( VisibilityFilters )
